var Layout    = require("enyo/Layout"),
    clipText  = require("app/utils/clipText"),
    kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageViewer.OverlayRightLayout.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageViewer.OverlayRightLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var appView      = this.container.app.view,
            container    = this.container,
            $description = container.$.description,
            $readMore    = container.$.readMore,
            descriptionNode,
            contentRegionHeight,
            availableSpace,
            descriptionHeight,
            readmoreHeight;

        if (!container.hasNode()) {
            return;
        }

        // Create a clean slate to measure dimensions
        $description.addStyles({
            visibility: "hidden"
        });
        descriptionNode = $description.hasNode();
        clipText.unclip(descriptionNode);
        $readMore.addStyles({
            visibility: "hidden"
        });
        $readMore.show();

        // Measure description dimensions and available space.
        contentRegionHeight = (appView.get("contentRegionBounds") || {height: 0}).height;
        availableSpace      = Math.min(
            contentRegionHeight * 0.192 - themeVars.getContentPaddingVerticalPx() * 2,
            themeVars.getBodyLineHeightPx() * 5
        );
        descriptionHeight   = (descriptionNode || {offsetHeight: 0}).offsetHeight;

        // Description is too large, it needs to be truncated
        if (descriptionHeight > availableSpace) {
            readmoreHeight = ($readMore.hasNode() || {offsetHeight: 0}).offsetHeight;
            availableSpace -= readmoreHeight;
            clipText.clip(descriptionNode, availableSpace, true);
        }
        else {
            $readMore.hide();
        }

        // Restore visibility
        $description.applyStyle("visibility", "visible");
        $readMore.applyStyle("visibility", "visible");
    }

});
